// Events the StreamWorker can emit
export const AudioEvent = {
  ACTION: 'ACTION',
  AUDIOLOG: 'AUDIOLOG',
  AUDIO_PROCESSED: 'AUDIO_PROCESSED',
  AUTH_REQUIRED: 'AUTH_REQUIRED',
  AUTHENTICATED: 'AUTHENTICATED',
  S2_NOTE_CREATED_IN_NOTEPAD: 'S2_NOTE_CREATED_IN_NOTEPAD',
  NOTE_CREATED: 'NOTE_CREATED',
  NOTE_DELETED: 'NOTE_DELETED',
  COMPOSITION_UPDATED: 'COMPOSITION_UPDATED',
  COMPOSITION_UPDATED_S2: 'COMPOSITION_UPDATED_S2',
  COMPOSITION_UPDATED_S2_FOR_UNDO: 'COMPOSITION_UPDATED_S2_FOR_UNDO',
  COMPOSITION_UPDATED_BY_SCRIBE: 'COMPOSITION_UPDATED_BY_SCRIBE',
  COMPOSITION_STATUS_UPDATED: 'COMPOSITION_STATUS_UPDATED',
  COMPOSITION_SUBMISSION_STATUS_UPDATED: 'COMPOSITION_SUBMISSION_STATUS_UPDATED',
  CONFIG: 'CONFIG',
  CURSOR_ACKNOWLEDGED: 'CURSOR_ACKNOWLEDGED',
  DISCONNECTED: 'DISCONNECTED',
  ERROR: 'ERROR',
  END_AUDIO_ON_ERROR: 'END_AUDIO_ON_ERROR',
  INTENT_FAILED: 'INTENT_FAILED',
  MUTE_AGENT: 'MUTE_AGENT',
  OFFLINE_TOAST: 'OFFLINE_TOAST',
  ONLINE_REMOVE_TOAST: 'ONLINE_REMOVE_TOAST',
  PONG_LATENCY: 'PONG_LATENCY',
  REFUSE_S2_CONNECTION: 'REFUSE_S2_CONNECTION',
  RECONNECTING: 'RECONNECTING',
  RECONNECT_SUCCESS: 'RECONNECT_SUCCESS',
  RECONNECT_ERROR: 'RECONNECT_ERROR',
  RECONNECT_FAILURE: 'RECONNECT_FAILURE',
  SPEECH_ENDED: 'SPEECH_ENDED',
  SPEECH_ERROR: 'SPEECH_ERROR',
  SPEECH_STARTED: 'SPEECH_STARTED',
  S2_ERROR: 'S2_ERROR',
  UNAUTHORIZED: 'UNAUTHORIZED'
}
